import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { loopbackDelete, loopbackGet, loopbackPost } from '../../loopback';
import { propertiesToURIQuery } from '../../utilities/objectHelper';
import {
  AppThunk,
  CLEAR_PUBLIC_SHARED_LINK,
  CREATE_SHAREDLINK,
  GET_SHAREDLINK,
  GET_SHAREDLINK_END,
  GET_SHAREDLINK_START,
} from '../types';
import { showErrorNotification } from './appActions';
import { clearSurveyRecord } from './surveyActions';

type sharedLinkItem = {
  code: string;
}

export const createSharedLink = (
  resource: string, item: sharedLinkItem,
): AppThunk => async (dispatch): Promise<void> => {
  const createdAt = moment.utc();
  const id = uuidv4();
  const postData = {
    id, createdAt, resource, item,
  };

  try {
    const response = await loopbackPost('PublicLinks', postData);
    dispatch({
      type: CREATE_SHAREDLINK,
      payload: response.id,
    });
  } catch (error: any) {
    dispatch(showErrorNotification(`Error during survey creation: ${error.stack}`));
  }
};

export const getSharedLink = (
  resource: string, prop: string, value: string,
): AppThunk => async (dispatch, getState): Promise<void> => {
  if (getState().publicSharedLink.fetchingSharedLink) {
    return;
  }
  dispatch({ type: GET_SHAREDLINK_START });
  const query = propertiesToURIQuery({ resource, prop, value });
  try {
    const response = await loopbackGet(`PublicLinks/findByItem?${query}`);
    dispatch({
      type: GET_SHAREDLINK,
      payload: response.id || null,
    });
    dispatch({ type: GET_SHAREDLINK_END });
  } catch (error) {
    dispatch({ type: GET_SHAREDLINK_END });
  }
};

export const deleteSharedLink = (id: string): AppThunk => async (dispatch): Promise<void> => {
  dispatch({ type: GET_SHAREDLINK_START });
  const response = await loopbackDelete(`PublicLinks/${id}`);
  if (response.count > 0) {
    dispatch({ type: CLEAR_PUBLIC_SHARED_LINK });
    dispatch(clearSurveyRecord());
  }
  dispatch({ type: GET_SHAREDLINK_END });
};
